import request from '@/utils/request'

// 返回各个省以及各个城市的名称
export function getCityInfo () {
  return request({
    url: '/ooh-dw/v1/open/service/listCityInfos',
    method: 'get'
  })
}
// 根据城市获取地铁线路信息
export function getAssetInfo (data) {
  return request({
    url: '/ooh-dw/v1/open/service/listAssets',
    method: 'get',
    params: data
  })
}
// 根据地铁线路id获取站台的排名
export function getRankInfo (data) {
  return request({
    url: '/ooh-dw/v1/open/service/listRanks',
    timeout: 200000,
    method: 'get',
    params: data
  })
}
// 获取站点客流数据
export function getStationFlow (data) {
  return request({
    url: '/ooh-dw/v1/open/service/getStationFlow',
    timeout: 200000,
    method: 'get',
    params: data
  })
}
